import { hiFromServerTime, selectErrorList, setErrorList, setIsAudioPermissionGranted, setIsTabVisible, setIsVideoPermissionGranted } from "@app/routes/treatmentV3/store/techStatusSlice";
import { createTreatmentEventPromise, createTreatmentMultipleEventPromise } from "@amplio-common/treatments/api";
import { wsUpdateStudentStatus, wsConnected, UNSAFE_selectGetWebsocket } from "@app/routes/treatmentV3/store/websocketSlice";
import { endVideoSession, setIsVideoMuted, setIsVideoPaused, userDeclineVideo, userStartVideo, videoSelectStudentStatusById, videoUpdateStudentStatus } from "@app/routes/treatmentV3/store/videoSlice";
import { selectIsShareScreenOn } from "@app/routes/treatmentV3/store/contentSlice";
import { fetchTreatmentById, selectFacilitatorStudent, selectFetchTreatmentPendingTime, selectTreatment } from "@app/routes/treatmentV3/store/treatmentServerDataSlice";
import { TREATMENT_EVENT_SOURCES } from "@app/routes/treatmentV3/constants";

const createEventData = ({ eventName, eventValue, eventProps, relevantToStudent, facilitatorStudent }) =>
  ({
    source: TREATMENT_EVENT_SOURCES.FRONT,
    event_name: eventName,
    event_value: eventValue,
    event_props: JSON.stringify(eventProps),
    relevant_to_student: relevantToStudent,
    facilitator_student: facilitatorStudent,
  });



export const trackTreatmentV3Metric = (eventName, state, eventValue, eventProps, relevantToStudent) => {
  // const currUser = currentUser(state);
  const treatment = selectTreatment(state);
  const treatmentId = treatment?.id;
  const facilitatorStudent = selectFacilitatorStudent(state)?.student?.id;
  
  treatmentId && eventName && setTimeout(async () => {
    try {
      const data = createEventData({ eventName, eventValue, eventProps, relevantToStudent, facilitatorStudent });
      await createTreatmentEventPromise(treatmentId, data);
    } catch (e) {
      console.error(`failed to send metric log ${eventName}:`, e);
    }
  }, 1);
};

export const trackTreatmentV3MultipleMetric = (eventNameList, state, eventValue, eventProps, relevantToStudent) => {
  const treatment = selectTreatment(state);
  const treatmentId = treatment?.id;
  const facilitatorStudent = selectFacilitatorStudent(state)?.student?.id;

  treatmentId && eventNameList && setTimeout(async () => {
    try {
      const resList = [];
      eventNameList.forEach(eventName => {
        const data = createEventData({ eventName, eventValue, eventProps, relevantToStudent, facilitatorStudent });
        resList.push(data);
      });
      await createTreatmentMultipleEventPromise(treatmentId, resList);
    } catch (e) {
      console.error(`failed to send multiple metric log ${eventNameList}:`, e);
    }
  }, 1);
};

export const relevantTreatmentV3MetricsBeforeActions = {
};

export const relevantTreatmentV3MetricsAfterActions = {
  // WS
  [wsUpdateStudentStatus]: (stateBefore, stateAfter, action) => {
    const studentId = action?.payload?.id;
    const { wsConnected: isConnected } = action?.payload?.changes || {};
    isConnected !== undefined && trackTreatmentV3Metric(`event_ws_student_${isConnected ? "connected" : "disconnected"}`, stateAfter, null, null, studentId);
  },
  [wsConnected]: (stateBefore, stateAfter) => {
    const websocket = UNSAFE_selectGetWebsocket(stateAfter);
    trackTreatmentV3Metric(`event_ws_user_${websocket ? "connected" : "disconnected"}`, stateAfter);
  },
  [hiFromServerTime]: (stateBefore, stateAfter, action) => {
    action?.payload && trackTreatmentV3Metric("event_ws_server_response", stateAfter, action?.payload);
  },
  ////// video
  [videoUpdateStudentStatus]: (stateBefore, stateAfter, action) => {
    const studentId = action?.payload?.id;
    const { isVideoPausedByTeacher: wasVideoPausedByTeacher,
      isVideoPaused: wasVideoPaused } = (s => videoSelectStudentStatusById(s, studentId))(stateBefore) || {};

    const { payload: { changes = {} } = {} } = action || {};
    const { isVideoPending, isVideoPausedByTeacher, isVideoPaused, isKickedFromVideo, isVideoOn } = changes;

    isKickedFromVideo && trackTreatmentV3Metric("event_video_educator_kick_student", stateAfter, null, null, studentId);
    //video status
    isVideoPending && trackTreatmentV3Metric("event_video_request_student_camera", stateAfter, null, null, studentId);
    //mute/pause by teacher
    isVideoPausedByTeacher !== undefined && isVideoPausedByTeacher !== wasVideoPausedByTeacher && isVideoOn && trackTreatmentV3Metric(`event_video_educator_${isVideoPausedByTeacher ? "paused" : "resumed"}_student_camera`, stateAfter, null, null, studentId);

    //mute/pause by student
    isVideoPaused !== undefined && isVideoPaused !== wasVideoPaused && isVideoOn && trackTreatmentV3Metric(`event_video_student_${isVideoPausedByTeacher ? "paused" : "resumed"}_camera`, stateAfter, null, null, studentId);
  },
  [userStartVideo.fulfilled]: (stateBefore, stateAfter) => {
    trackTreatmentV3Metric("event_video_user_start", stateAfter);
  },
  [userDeclineVideo]: (stateBefore, stateAfter) => {
    trackTreatmentV3Metric("event_video_user_decline", stateAfter);
  },
  [setIsVideoMuted]: (stateBefore, stateAfter, action) => {
    const isVideoMuted = action.payload;
    isVideoMuted !== undefined && trackTreatmentV3Metric(`event_video_user_${isVideoMuted ? "muted" : "unmuted"}`, stateAfter);
  },
  [setIsVideoPaused]: (stateBefore, stateAfter, action) => {
    const isVideoPaused = action.payload;
    isVideoPaused !== undefined && trackTreatmentV3Metric(`event_video_user_${isVideoPaused ? "paused" : "resumed"}`, stateAfter);
  },
  [endVideoSession]: (stateBefore, stateAfter) => {
    const isShareScreenOn = selectIsShareScreenOn(stateBefore);
    trackTreatmentV3Metric("event_video_educator_end_session", stateAfter, null, { isShareScreenOn });
  },

  //tech stats
  [setIsAudioPermissionGranted]: (stateBefore, stateAfter, action) => {
    action?.payload === false && trackTreatmentV3Metric("error_tech_assist_permission_audio", stateAfter);
  },
  [setIsVideoPermissionGranted]: (stateBefore, stateAfter, action) => {
    action?.payload === false && trackTreatmentV3Metric("error_tech_assist_permission_video", stateAfter);
  },
  [setIsTabVisible]: (stateBefore, stateAfter, action) => {
    action?.payload === false && trackTreatmentV3Metric("error_tech_assist_tab_visibility", stateAfter);
  },
  [setErrorList]: (stateBefore, stateAfter, action) => {
    const errorListChanges = action?.payload;
    
    if (errorListChanges) {
      const prevErrorList = selectErrorList(stateBefore); //prev student tech errors

      const newActiveErrors = [];
      Object.entries(errorListChanges).forEach(err => {
        // err[1]?.isActive !== prevErrorList[err[0]]?.isActive && errorChanges.push({ [err[0]]: err[1]?.isActive });
        err[1]?.isActive && err[1]?.isActive !== prevErrorList[err[0]]?.isActive && newActiveErrors.push(err[0]);
      });

      newActiveErrors?.length && trackTreatmentV3MultipleMetric(newActiveErrors, stateAfter);
    }
  },

  //treatment
  [fetchTreatmentById.fulfilled]: (stateBefore, stateAfter) => {
    const fetchTreatmentPendingTime = selectFetchTreatmentPendingTime(stateAfter);
    fetchTreatmentPendingTime && trackTreatmentV3Metric("event_initial_load", stateAfter, fetchTreatmentPendingTime);
  },
};
